import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Empty,
  Divider,
  InputNumber,
  Input,
} from "antd";
import styled from "styled-components";
import ProductCard from "../productCard";
import { useHistory } from "react-router-dom";
import { BsChevronLeft } from "react-icons/bs";
import { BsChevronRight } from "react-icons/bs";
import { AiOutlinePlus } from "react-icons/ai";
import CustomModal from "../modals/customModal";
import LoaderGif from "../../assets/images/ie_loader.gif";

import Delete_order from "../../assets/images/delete_order.png";
import Configuration from "../../assets/images/configuration.png";
const CatalogCardWrapper = styled(Card)`
  min-height: 350px;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 16%);
  margin-top: 40px;

  .table-filters {
    height: 2rem;
    text-align: center;
    border-color: #9e9e9e;
    border-radius: 0px;
    font-size: 14px;
    width: auto;
  }
  .table-filters-heading {
    font-size: 0.8rem;
    color: #000;
    padding-right: 10px;
  }
`;
const productData = [];
function CatalogCard({
  products,
  categoryName,
  onChangeFilter,
  onChangeShowingFilter,
  previousPage,
  currentPage,
  metaData,
  updateProductPrice,
  onUpdateProductPrice,
  onOpenModal,
  value,
  updateProduct,
  fromNewCatalog,
  NewCatalogInput,
  postProduct,
  isLoading,
  callOnCallBack,
  isProductLoading,
  dividerShow,
  iscardTrue,
  onAdd
}) {
  const history = useHistory();
  let [isOpenModal, setIsOpenModal] = useState(false);
  const [productId, setProductId] = useState("");
  const [configModal, setConfigModal] = useState(false);
  const [product, setProduct] = useState([]);
  // const [additivesProduct, setAddtiveProduct] = useState([]);
  const onUpdateRmxPrice = (e, index) => {
    const arr = {...product};
    arr.rmx_product_additives[index].price = e;
    setProduct(arr);
  };
  const onChangeOnAdd = (e, index, name) => {
    const arr = product;
    arr.product_additives[index] = {
      name,
      description: "",
      price: e,
    };
    setProduct(arr);
  };

  const onAddProduct = () => {
    productData.push({ ...product, isSave: true });
    setConfigModal(false);
    if(onAdd){
      onAdd(productData)
    }
  };
  console.log("PRODUCT_DATA==>", isProductLoading);
  return (
    <Row>
      <Col span={24}>
        {iscardTrue ? (
          <>
            <Row
              justify="space-between"
              style={{
                borderBottom: dividerShow ? "1px solid lightgrey" : "",
              }}
            >
              <Col xl={12} xs={24} sm={24} md={12}>
                <h5 className="text-left" style={{ paddingLeft: "20px" }}>
                  {categoryName}
                </h5>
              </Col>
              <Col xl={12} xs={24} sm={24} md={12}>
                {!fromNewCatalog ? (
                  <h2
                    className="text-right pointer-cursor"
                    onClick={() => history.push("/catalog/new")}
                  >
                    <AiOutlinePlus size={20}  className="pointer-cursor"/>
                  </h2>
                ) : null}
              </Col>
            </Row>
            <Row justify="space-between" style={{ padding: "1rem 01rem 0" }}>
              <Col xl={4} lg={4} md={4} sm={7} xs={7}>
                <span className="table-filters-heading">Sort by</span>
                <select
                  className="table-filters"
                  onChange={(e) => onChangeFilter(e.target.value)}
                >
                  <option>Price</option>
                  <option>Name</option>
                </select>
              </Col>
              <Col xl={4} lg={4} md={4} sm={7} xs={7}>
                <span className="table-filters-heading">Showing</span>
                <select
                  className="table-filters"
                  onChange={(e) => onChangeShowingFilter(e.target.value)}
                >
                  <option>12</option>
                  <option>24</option>
                  <option>48</option>
                  <option>96</option>
                </select>
              </Col>
            </Row>
            <Row>
              {products.length ? (
                products.map((item) => {
                  return (
                    <Col xl={8} lg={8} md={6} xs={24} sm={24}>
                      <ProductCard
                        fromNewCatalog={fromNewCatalog}
                        data={item}
                        onAdd={(e) => {
                          setConfigModal(true);
                          setProductId(item.id);
                          setProduct(item);
                          onOpenModal(item.price);
                        }}
                        onConfigure={(e) => {
                          setConfigModal(true);
                          setProductId(item.id);
                          setProduct(item);
                          onOpenModal(item.price);
                        }}
                        onDeactive={(e) => {
                          setIsOpenModal(true);
                          setProductId(item.id);
                          setProduct(item);
                        }}
                        productData={productData}
                      />
                    </Col>
                  );
                })
              ) : (
                <Col span={24}>
                  {isLoading && (
                    <img src={LoaderGif} height={"60"} width={"60"} />
                  )}
                  {!isLoading && (
                    <Empty description={"Nothing to show right now."} />
                  )}
                </Col>
              )}
            </Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Row
                gutter={[5, 0]}
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                justify="start"
              >
                <Col className="tablePagination">
                  {`Displaying ${metaData?.currentCount} of ${metaData?.totalCount}`}
                  <Button
                    type="link"
                    icon={<BsChevronLeft color="#686868" size={15} />}
                    onClick={previousPage}
                    disabled={metaData.page === 1}
                  />
                  {/* For  Showing Page-No */}
                  {metaData?.page}
                  <Button
                    type="link"
                    icon={<BsChevronRight color="#686868" size={15} />}
                    onClick={currentPage}
                    disabled={metaData.total_pages === metaData.page}
                  />
                </Col>
              </Row>
            </Col>
          </>
        ) : (
          <CatalogCardWrapper>
            <Row
              justify="space-between"
              style={{
                borderBottom: dividerShow ? "1px solid lightgrey" : "",
                padding: "1rem 0 1rem 0",
              }}
            >
              <Col span={12} xl={12} xs={24} sm={24}>
                <h5 className="text-left">{categoryName}</h5>
              </Col>
              <Col span={12} xl={12} xs={24} sm={24}>
                {!fromNewCatalog ? (
                  <h2
                    className="text-right pointer-cursor"
                    onClick={() => history.push("/catalog/new")}
                  >
                    <AiOutlinePlus size={20} className="pointer-cursor" />
                  </h2>
                ) : null}
              </Col>
            </Row>
            <Row justify="space-between" style={{ padding: "1rem 01rem 0" }}>
              <Col xl={4} lg={4} md={4} sm={7} xs={7}>
                <span className="table-filters-heading">Sort by</span>
                <select
                  className="table-filters"
                  onChange={(e) => onChangeFilter(e.target.value)}
                >
                  <option>Price</option>
                  <option>Name</option>
                </select>
              </Col>
              <Col xl={4} lg={4} md={4} sm={7} xs={7}>
                <span className="table-filters-heading">Showing</span>
                <select
                  className="table-filters"
                  onChange={(e) => onChangeShowingFilter(e.target.value)}
                >
                  <option>12</option>
                  <option>24</option>
                  <option>48</option>
                  <option>96</option>
                </select>
              </Col>
            </Row>
            <Row>
              {products.length ? (
                products.map((item) => {
                  return (
                    <Col xl={8} lg={8} md={9} xs={24} sm={24}>
                      <ProductCard
                        fromNewCatalog={fromNewCatalog}
                        data={item}
                        onAdd={(e) => {
                          setConfigModal(true);
                          setProductId(item.id);
                          setProduct(item);
                          onOpenModal(item.price);
                        }}
                        onConfigure={(e) => {
                          setConfigModal(true);
                          setProductId(item.id);
                          setProduct(item);
                          onOpenModal(item.price);
                        }}
                        onDeactive={(e) => {
                          setIsOpenModal(true);
                          setProductId(item.id);
                          setProduct(item);
                        }}
                        productData={productData}
                      />
                      
                    </Col>
                  );
                })
              ) : (
                <Col span={24}>
                  {isLoading && (
                    <img src={LoaderGif} height={"60"} width={"60"} />
                  )}
                  {!isLoading && (
                    <Empty description={"Nothing to show right now."} />
                  )}
                </Col>
              )}
            </Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Row
                gutter={[5, 0]}
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                justify="end"
              >
                <Col className="tablePagination">
                  {`Displaying ${metaData?.currentCount} of ${metaData?.totalCount}`}
                  <Button
                    type="link"
                    icon={<BsChevronLeft color="#686868" size={15} />}
                    onClick={previousPage}
                    disabled={metaData.page === 1}
                  />
                  {/* For  Showing Page-No */}
                  {metaData?.page}
                  <Button
                    type="link"
                    icon={<BsChevronRight color="#686868" size={15} />}
                    onClick={currentPage}
                    disabled={metaData.total_pages === metaData.page}
                  />
                </Col>
              </Row>
            </Col>
          </CatalogCardWrapper>
        )}

        <CustomModal
          visible={configModal}
          onCancelModal={() => setConfigModal(false)}
          footer={[
            <Row justify="end">
              <Col span={24} style={{ width: "100%" }}>
                <Button
                  style={{
                    backgroundColor: "#fff",
                    color: "black",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => setConfigModal(false)}
                >
                  CANCEL
                </Button>

                {!NewCatalogInput ? (
                  <Button
                    style={{
                      backgroundColor: "#ff9800 ",
                      color: "#fff",
                      width: "30%",
                      border: "none",
                    }}
                    onClick={() =>
                      updateProductPrice(
                        {
                          price: product.price,
                          rmx_product_additives: product.rmx_product_additives,
                        },
                        productId,
                        null,
                        () => {
                          setConfigModal(false);
                        }
                      )
                    }
                  >
                    SAVE
                  </Button>
                ) : (
                  <Button
                    style={{
                      backgroundColor: "#ff9800 ",
                      color: "#fff",
                      width: "30%",
                      border: "none",
                    }}
                    onClick={() =>  onAddProduct()}
                  >
                    Save
                  </Button>
                )}
              </Col>
            </Row>,
          ]}
        >
          <Row
            justify="space-between"
            style={{ marginBottom: "30px" }}
            gutter={[10, 0]}
          >
            <Col span={12}>
              <h5 className="text-left">{product?.name}</h5>
            </Col>
            <Col xs={12} sm={12} md={8} lg={8} xl={8}>
              <span style={{ paddingRight: "5px", fontSize: "1.1rem" }}>$</span>
              <InputNumber
                min={1}
                max={100000}
                onChange={(e) => {
                  const arr = {...product};
                  arr.price = e;
                  setProduct(arr);
                }}
                name="price"
                value={product?.price}
              />
              <span style={{ paddingLeft: "5px", fontSize: "1.1rem" }}>
                /CY
              </span>
            </Col>
          </Row>
          <Row>
            <Col span={9}>
              <img
                src={product?.image?.medium}
                style={{ objectFit: "contain", width: "90%" }}
              />
            </Col>
            <Col
              span={14}
              style={{ border: "1px solid #F0F0F0", padding: "0.5rem" }}
            >
              <Row>
                <Col span={12} style={{ position: "relative" }}>
                  <img
                    src={Configuration}
                    style={{
                      width: "100%",
                      position: "absolute",
                      backgroundRepeat: "no-repeat",
                      top: "-20px",
                    }}
                  />
                </Col>
                <Col
                  span={24}
                  style={{
                    height: "8rem",
                    overflowY: "auto",
                    overflowX: "hidden",
                    margin: "5px",
                  }}
                >
                  {}
                  {!NewCatalogInput
                    ? (product.rmx_product_additives || []).map(
                        (item, index) => {
                          return (
                            <Row
                              justify="space-between"
                              align="middle"
                              style={{ marginBottom: "5px" }}
                            >
                              <Col span={14}>{item.name}</Col>
                              <Col span={6}>
                                <InputNumber
                                  min={1}
                                  max={100000}
                                  onChange={(e) => onUpdateRmxPrice(e, index)}
                                  name="price"
                                  value={item.price}
                                />
                              </Col>
                              <Col span={4}></Col>
                            </Row>
                          );
                        }
                      )
                    : (product.product_additives || []).map((item, index) => {
                        return (
                          <Row
                            justify="space-between"
                            align="middle"
                            style={{ marginBottom: "5px" }}
                          >
                            <Col span={14}>
                              {product.additives[index]["name"]}
                            </Col>
                            <Col span={6}>
                              <InputNumber
                                min={1}
                                max={100000}
                                onChange={(e) =>
                                  onChangeOnAdd(
                                    e,
                                    index,
                                    product.additives[index]["name"]
                                  )
                                }
                                name="price"
                                value={item.price}
                              />
                            </Col>
                            <Col span={4}></Col>
                          </Row>
                        );
                      })}
                </Col>
              </Row>
            </Col>
          </Row>
        </CustomModal>
        <CustomModal
          visible={isOpenModal}
          onCancelModal={() => setIsOpenModal(false)}
          footer={[
            <Row justify="center" style={{ margin: "20px" }}>
              <Col
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
              >
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() =>
                    updateProduct(
                      {},
                      productId,
                      product.status === 1 ? "deactivate" : "activate",
                      () => {
                        callOnCallBack();
                        setIsOpenModal(false);
                      }
                    )
                  }
                >
                  YES
                </Button>
                <Button
                  style={{
                    backgroundColor: "#26a69a ",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => setIsOpenModal(false)}
                >
                  NO
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col className="d-flex justify-content-center" span={24}>
              <img src={Delete_order} />
            </Col>
            <Col span={12} style={{ textAlign: "center" }}>
              <span>
                {product.status === 1
                  ? "Are you sure you want to deactivate this product"
                  : "Are you sure you want to activate this product"}
              </span>
            </Col>
          </Row>
        </CustomModal>

        {productData.some((item) => item.id === productId)&&!onAdd ? (
          <Row justify="end">
            {isProductLoading ? (
              <img src={LoaderGif} height={"60"} width={"60"} />
            ) : (
              <Col>
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    // width: "50%",
                    marginTop: "20px",
                  }}
                  onClick={() =>
                    postProduct(productData, () => history.push("/catalog"))
                  }
                >
                  ADD
                </Button>
              </Col>
            )}
          </Row>
        ) : (
          ""
        )}
      </Col>
    </Row>
  );
}
export default CatalogCard;
